import Vue from 'vue';
import KEYS from '../../../values/keys';

export default Vue.component('ed-meeting-member', {
  props: ['member', 'isLoading'],
  computed: {
    loading(): any {
      return { [KEYS.CSS.EDG_SHIMMER_CONTAINER] : this.isLoading };
    },
    initials(): string {
      if(this.member) {
        let firstLetter = this.member.firstName.charAt(0);
        let secondLetter = this.member.lastName ? this.member.lastName.charAt(0) : '';
        return `${firstLetter}${secondLetter}`;
      }
      return '';
    }
  }
});